module.exports = __webpack_public_path__ + "static/media/muller-logo-charcoal.c68b9cc9.svg";